import React from "react";
import { Box, ClickAwayListener, Grow, Popper } from "@mui/material";
import styles from "./customPopover.module.scss";
import PropTypes from "prop-types";

const CustomPopover = (props) => {
  const {
    anchorEl,
    content,
    customPlacement = "bottom-start",
    open,
    handleClose,
    hasArrow = true,
  } = props;

  return (
    <Box className={styles.popoverWrapper} data-testid="custompopover">
      <Popper
        open={open}
        anchorEl={anchorEl?.current}
        role={undefined}
        placement={customPlacement}
        transition
        disablePortal={false}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Box>
              <ClickAwayListener
                onClickAway={() => handleClose()}
              >
                <Box>
                  {hasArrow ? (
                    <Box
                      sx={{
                        position: "relative",
                        display:
                          placement === "bottom-start" ||
                          placement === "bottom" ||
                          placement === "bottom-end"
                            ? "inherit"
                            : "none",

                        mt: "10px",
                        "&::before": {
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #D6D6D6",
                          borderBottom: "none",
                          borderRight: "none",
                          content: '""',
                          display: "block",
                          position: "absolute",
                          width: 12,
                          height: 12,
                          top: -6,
                          transform: "rotate(45deg)",
                          left: placement === "bottom" ? "50%" : "25px",
                        },
                      }}
                    />
                  ) : null}
                  <Box
                    sx={{
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #D6D6D6 !important",
                    }}
                  >
                    {content}
                  </Box>
                  {hasArrow ? (
                    <Box
                      sx={{
                        position: "relative",
                        display:
                          placement === "top-start" ||
                          placement === "top" ||
                          placement === "top-end"
                            ? "inherit"
                            : "none",

                        mt: "10px",
                        "&::before": {
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #D6D6D6",
                          borderTop: "none",
                          borderLeft: "none",
                          content: '""',
                          display: "block",
                          position: "absolute",
                          width: 12,
                          height: 12,
                          bottom: 4,
                          transform: "rotate(45deg)",
                          left: placement === "top" ? "50%" : "25px",
                        },
                      }}
                    />
                  ) : null}
                </Box>
              </ClickAwayListener>
            </Box>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default CustomPopover;
CustomPopover.propTypes = {
  anchorEl: PropTypes.any,
  content: PropTypes.any,
  customPlacement: PropTypes.any,
  open: PropTypes.any,
  handleClose: PropTypes.any,
  hasArrow: PropTypes.any,
};
